import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import {
	IEvaluationDetail,
	IEvaluations,
} from '../interfaces/evaluations.interface';

@Injectable()
export class EvaluationsService {
	servicesUrl = environment.servicesUrl;

	constructor(private http: HttpClient) {}

	getEvaluations(userId): Observable<IEvaluations> {
		return this.http.get<IEvaluations>(
			`${this.servicesUrl}/journeys/screening/office/${userId}/evaluations`
		);
	}

	getEvaluationById(userId, evaluationId): Observable<IEvaluationDetail> {
		return this.http.get<IEvaluationDetail>(
			`${this.servicesUrl}/journeys/screening/office/${userId}/evaluations/${evaluationId}`
		);
	}
}
